export default __webpack_public_path__ + "static/media/stakeholders.cbe557b6.jpg";